module.exports = __webpack_public_path__ + "img/impostor-silhouete.e1af9cb6.png";